import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, Tooltip } from 'antd';
import { FileExcelOutlined } from '@ant-design/icons';
import useDownloadAsExcel from 'hooks/useDownloadAsExcel';
import messages from './messages';

const DownloadTextResponses = ({ title, themes, sentiments, responses }) => {
  const download = useDownloadAsExcel();

  const onDownload = useCallback(async () => {
    const themeColumnHeaders = themes?.map(t => t.text);
    const sentimentColumnHeaders = sentiments?.map(s => s.text);

    const sheetData = responses
      .map((r => ({
        Segment: r.segments?.length > 0 ? [...new Set(r.segments?.map(s => s.name))].join(', ') : '',
        Date: r.surveyResponse.respondedAt,
        'Page URL': r.surveyResponse.webpageUrl,
        'Page Title': r.surveyResponse.webpageTitle,
        Answer: r.text,
        ...r.themes?.reduce((obj, t) => ({ ...obj, [t.text]: 1 }), {}),
        ...r.sentiments?.reduce((obj, s) => ({ ...obj, [s.text]: 1 }), {}),
      })));

    const sheetHeader = [
      'Segment',
      'Date',
      'Page URL',
      'Page Title',
      'Answer',
      ...sentimentColumnHeaders,
      ...themeColumnHeaders,
    ];

    download({
      fileName: title,
      sheetTitle: 'Responses',
      sheetHeader,
      sheetData,
    });
  });

  return (
    <Tooltip title={<FormattedMessage {...messages.downloadTooltip} />}>
      <Button
        onClick={onDownload}
        icon={<FileExcelOutlined />}
        disabled={!responses?.length}
      />
    </Tooltip>
  );
};

export default DownloadTextResponses;
